import { useEffect } from 'react';
import { isAnonymousFlowEnabled } from 'arbitrip-common/client/utils/ElalSamlVerification';
import URLS from '../utils/ApiURLs';
import { isElalCompany } from '../utils/isCompany';
import ProfileStore from '../stores/ProfileStore';

const ELAL_SAML_VERIFIED_KEY = 'elal_saml_verified';
const ELAL_SAML_VERIFIED_PARAM = 'saml_verified';
const SEARCH_TOKEN_PARAM = 'search_token';

export function isSamlRedirectNeeded(permission) {
    if (!isElalCompany()) return false;
    if (!ProfileStore.isServerProfileLoaded()) return false;
    const profile = ProfileStore.getProfile();
    if (profile?.isLoggedIn) return false;
    if (profile?.anonymous && isAnonymousFlowEnabled(profile, permission)) return false;
    const params = new URLSearchParams(window.location.search);
    if (params.has(ELAL_SAML_VERIFIED_PARAM)) return false;
    if (params.has(SEARCH_TOKEN_PARAM)) return false;
    if (sessionStorage.getItem(ELAL_SAML_VERIFIED_KEY)) return false;
    return true;
}

function useSamlPageVerification(permission) {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.has(ELAL_SAML_VERIFIED_PARAM)) {
            sessionStorage.setItem(ELAL_SAML_VERIFIED_KEY, '1');
        }

        const check = () => {
            if (!isSamlRedirectNeeded(permission)) return;
            window.location.replace(URLS.LOGIN + '?ref_url=' + encodeURIComponent(window.location.href));
        };

        check();
        ProfileStore.addChangeListener(check);
        return () => ProfileStore.removeChangeListener(check);
    }, []);
}

export default useSamlPageVerification;
